export const languages = {
        en: {
            search: 'Search',
            placeholderText: 'What do you want to watch today?'
        },
        hin: {
            search: 'खोज',
            placeholderText: 'आज आप क्या देखना चाहते हैं?'
        },
        spanish: {
            search: 'Buscar',
            placeholderText: `¿Qué quieres ver hoy?`
        },
        french: {
            search: 'Recherche',
            placeholderText: `Que veux-tu regarder aujourd’hui ?`
        },
        german: {
            search: 'Suchen',
            placeholderText: 'Was möchtest du heute sehen?'
        },
    }